import React, { useState, useEffect, useRef, useCallback } from 'react';

const SummaryDetail = ({ summary, detail }) => {
    const [collapsed, setCollapsed] = useState(true)
    const summaryDetailRef = useRef(null)
    const texteRef = useRef(null)

    const _onResize = useCallback(() => {
        if (!texteRef.current || !summaryDetailRef.current) return
        const { height } = texteRef.current.getBoundingClientRect()
        const summaryHeight = height + 23
        summaryDetailRef.current.style.height = summaryHeight + "px"
    }, [])

    useEffect(() => {
        _onResize()
    }, [_onResize])

    const _onClick = () => {
        setCollapsed(prev => !prev)
    }

    const className = collapsed ? "collapsed" : ""
    return (
        <div className={"summary-detail " + className} ref={summaryDetailRef}>
            <div className={`summary has-icon ${collapsed ? 'chevron-n' : 'chevron-s'}`} onClick={_onClick}>
                <span>{summary}</span>
            </div>
            <div className="details">
                <div className="texte" ref={texteRef}
                    dangerouslySetInnerHTML={{
                        __html: detail,
                    }}
                ></div>
            </div>
        </div>
    );
}

export default SummaryDetail;
